module.exports = __webpack_public_path__ + "static/media/communityWitnessLogo.9daa2d5e.webp";